import { SerializableErrorInfo } from "@insightfulscience/smart-react/ApplicationError";
import { ERROR_ACCOUNT_REVIEW_REQUIRED } from "@domain/errors";

import Error400 from "./Error400";
import Error401 from "./Error401";
import Error403 from "./Error403";
import Error404 from "./Error404";
import Error500 from "./Error500";
import Error503 from "./Error503";
import ErrorAccountReviewRequired from "./ErrorAccountReviewRequired";

const errorComponentsByErrorCode = new Map([
	[ERROR_ACCOUNT_REVIEW_REQUIRED, ErrorAccountReviewRequired],
]);

const errorComponents = new Map([
	[400, Error400],
	[401, Error401],
	[403, Error403],
	[404, Error404],
	[503, Error503],
]);

export type AppErrorProps = {
	error: SerializableErrorInfo;
};

const AppError = ({ error }: AppErrorProps) => {
	const ErrorComponent =
		errorComponentsByErrorCode.get(`${error?.tags?.errorCode}`) ??
		errorComponents.get(+error.code) ??
		Error500;

	return <ErrorComponent error={error} />;
};

export default AppError;
